import React from 'react';
import _ from 'lodash';

import Master from '../../Components/Master';
import { ColumnHeaderCell, EditableCell, Cell, Column, Table } from "@blueprintjs/table";


export default class TableDummy extends Master {

    state = {
        mitarbeiter: {}
    }

    shouldComponentUpdate(nextProps, nextState) {
        var doReturn = false
        if(nextProps.mitarbeiter !== nextState.mitarbeiter) {
            doReturn = true
            this.state.mitarbeiter = nextProps.mitarbeiter
        }
        return doReturn
    }

	mitarbeiter_cellRenderer = (rowIndex, columnIndex)  => {
        var name = this.props.mitarbeiter[rowIndex]
		return <Cell>{name.familienname} {name.name}</Cell>
	}

    onSelection = (region) => {
        var userRow = region[0].rows[0]
        var user = this.props.mitarbeiter[userRow]
        this.props.selectUser(user.id)
    }

	render() {

        var {
            mitarbeiter
        } = this.props

		return (
			<Table
                defaultColumnWidth={200}
                numRows={mitarbeiter.length}
                onSelection={this.onSelection}
 			>
				<Column
					name="Mitarbeiter"
					cellRenderer={this.mitarbeiter_cellRenderer}
				/>
			</Table>
		)
	}
}


// WEBPACK FOOTER //
// ./src/Routes/Monatsuebersicht/mitarbeiter.js